// Module
var code = `<div class="go-pdf-page-content"><canvas class="go-pdf-canvas" aria-hidden="true"></canvas><div class="go-pdf-text-layer textLayer"></div><div class="go-pdf-annotation-layer annotationLayer"></div></div><div class="loading-indicator" ng-if="isRendering"><span class="ficon-spinner ficon-spin"></span></div>`;
// Exports
export default code;